import { CSSProperties, ReactNode, SyntheticEvent } from 'react';
import {
  ListItemButton as MUIListItemButton,
  ListItemButtonProps as MUIListItemButtonProps,
} from '@mui/material';

type AtomMUIProps = {
  style?: CSSProperties;
  className?: string;
  children?: ReactNode;
  disableGutters?: boolean;
  onClick?: (event: SyntheticEvent<any>) => void;
  sx?: any;
  selected?: boolean;
  id?: string;
  disabled?: boolean;
  disableRipple?: boolean;
  'data-cy'?: string;
};

export type ListItemButtonProps = AtomMUIProps;

export const ListItemButton = (props: ListItemButtonProps) => {
  const { style = {}, ...data } = props;

  const MUIProps: MUIListItemButtonProps = data;

  return <MUIListItemButton {...MUIProps} style={style} />;
};

export default ListItemButton;
